import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { offlineActions } from "../backend/store/reducers/offlineReducer";

/**
 * Binds the browser's online/offline events to the offlineStore slice.
 * Mounted exactly once, from App — mounting it twice would double-dispatch
 * (harmless but noisy in devtools).
 */
export const useConnectivity = (): void => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleOnline = () => dispatch(offlineActions.setOnlineAC(true));
    const handleOffline = () => dispatch(offlineActions.setOnlineAC(false));

    // Seed from the current value: the app may have booted while already offline,
    // in which case no event will ever fire to tell us.
    dispatch(offlineActions.setOnlineAC(window.navigator.onLine));

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, [dispatch]);
};
